(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[195],{

/***/ 7484:
/***/ (function(module) {

!function(t,e){ true?module.exports=e():0}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",f="month",h="quarter",c="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,f),s=n-i<0,u=e.clone().add(r+(s?-1:1),f);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:f,y:c,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:h}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p=function(t){return t instanceof _},S=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},w=function(t,e){if(p(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},O=v;O.l=S,O.i=p,O.w=function(t,e){return w(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=S(t.locale,null,!0),this.parse(t)}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(O.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.$x=t.x||{},this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return O},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=w(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return w(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<w(t)},m.$g=function(t,e,n){return O.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!O.u(e)||e,h=O.p(t),l=function(t,e){var i=O.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return O.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(h){case c:return r?l(1,0):l(31,11);case f:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=O.p(t),h="set"+(this.$u?"UTC":""),l=(n={},n[a]=h+"Date",n[d]=h+"Date",n[f]=h+"Month",n[c]=h+"FullYear",n[u]=h+"Hours",n[s]=h+"Minutes",n[i]=h+"Seconds",n[r]=h+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===f||o===c){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[O.p(t)]()},m.add=function(r,h){var d,l=this;r=Number(r);var $=O.p(h),y=function(t){var e=w(l);return O.w(e.date(e.date()+Math.round(t*r)),l)};if($===f)return this.set(f,this.$M+r);if($===c)return this.set(c,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return O.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=O.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,f=n.months,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},c=function(t){return O.s(s%12||12,t,"0")},d=n.meridiem||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r},$={YY:String(this.$y).slice(-2),YYYY:this.$y,M:a+1,MM:O.s(a+1,2,"0"),MMM:h(n.monthsShort,a,f,3),MMMM:h(f,a),D:this.$D,DD:O.s(this.$D,2,"0"),d:String(this.$W),dd:h(n.weekdaysMin,this.$W,o,2),ddd:h(n.weekdaysShort,this.$W,o,3),dddd:o[this.$W],H:String(s),HH:O.s(s,2,"0"),h:c(1),hh:c(2),a:d(s,u,!0),A:d(s,u,!1),m:String(u),mm:O.s(u,2,"0"),s:String(this.$s),ss:O.s(this.$s,2,"0"),SSS:O.s(this.$ms,3,"0"),Z:i};return r.replace(y,(function(t,e){return e||$[t]||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=O.p(d),M=w(r),m=(M.utcOffset()-this.utcOffset())*e,v=this-M,g=O.m(this,M);return g=($={},$[c]=g/12,$[f]=g,$[h]=g/3,$[o]=(v-m)/6048e5,$[a]=(v-m)/864e5,$[u]=v/n,$[s]=v/e,$[i]=v/t,$)[y]||v,l?g:O.a(g)},m.daysInMonth=function(){return this.endOf(f).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=S(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return O.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),T=_.prototype;return w.prototype=T,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",f],["$y",c],["$D",d]].forEach((function(t){T[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),w.extend=function(t,e){return t.$i||(t(e,_,w),t.$i=!0),w},w.locale=S,w.isDayjs=p,w.unix=function(t){return w(1e3*t)},w.en=D[g],w.Ls=D,w.p={},w}));

/***/ }),

/***/ 7286:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog",
      function () {
        return __webpack_require__(2149);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/container/base.jsx + 3 modules
var base = __webpack_require__(5216);
;// CONCATENATED MODULE: ./components/container/default.jsx

function Default(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "flex flex-col max-w-7xl mx-auto px-6",
        children: children
    });
}

;// CONCATENATED MODULE: ./components/container/index.jsx
// COMPONENTS



function Container(param) {
    let { children , blackOut , noFooter  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(base/* default */.Z, {
        blackOut: blackOut,
        noFooter: noFooter,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Default, {
            children: children
        })
    });
}


/***/ }),

/***/ 3517:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ config; },
  "r": function() { return /* binding */ configSet; }
});

;// CONCATENATED MODULE: ./public/logo.png
/* harmony default export */ var logo = ({"src":"/_next/static/media/logo.ad9b92b2.png","height":512,"width":512,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXFCgbsQRIZOd6F2gFtCkMW/pioFQpEAEzYiVYFKZWfywQ+ckD0qaZw3frI0eKwydaksbaAAMG5sjauguNCVrcV5nLx6mbU6ZJaimlJQamhgcl+Dg0dTbWNNoNf///+jl0Ief3V8AAAAHnRSTlMA/VRj9vr8Mw5uef75sNz5/tZahNr+u7k9/mL09ewQFWwFAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAQklEQVR4nB3GRxKAIBAAwSEpLCjmnP7/Si371IBHN7kFM/bhcg6me+hUXcEyGx88bKJFAOyj1qIE9mjjnzMdyX55AVwDAnzXIZPiAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./lib/pageConfig.js

// eslint-disable-next-line import/prefer-default-export
const config = {
    siteName: "Dr.Doc AI",
    blogTitle: "Blog",
    baseUrl: "drdoc.ai",
    websiteLogo: logo,
    twitterHandle: "@junaid_builds",
    twitterCardType: "Dr.Doc AI Blog",
    css: {
        primaryColor: "#111",
        accentColor: "#455A64",
        lightGray: "#eeeeee",
        backgroundColor: "#fff",
        black: "#111",
        white: "#fff",
        textColor: "#333",
        opacity: 0.7
    }
};
const privacy = {
    ...config,
    siteDescription: "Privacy policy for AI Doctor Documentation Tool ",
    defaultPageTitle: "Privacy | Dr.Doc AI"
};
const FAQ = {
    ...config,
    siteDescription: "Frequently asked questions for Dr.Doc AI",
    defaultPageTitle: "FAQ | Dr.Doc AI"
};
const landing = {
    ...config,
    siteDescription: "Dr.Doc AI will quickly transcribe and format your appointment notes with your exact format - in seconds.",
    defaultPageTitle: "AI Clinical Documentation | Dr.Doc AI "
};
const thankYou = {
    ...config,
    siteDescription: "Dr.Doc AI will quickly transcribe and format your appointment notes with your exact format - in seconds.",
    defaultPageTitle: "Get In Touch | Dr.Doc AI"
};
const blogHome = {
    ...config,
    siteDescription: "Dr.Doc AI will quickly transcribe and format your appointment notes with your exact format - in seconds.",
    defaultPageTitle: "Blog | Dr.Doc AI"
};
const configSet = {
    FAQ,
    privacy,
    landing,
    blogHome,
    thankYou
};


/***/ }),

/***/ 2149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ArticlesIndex; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(7484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./utils/seo.js
var seo = __webpack_require__(3298);
// EXTERNAL MODULE: ./lib/pageConfig.js + 1 modules
var pageConfig = __webpack_require__(3517);
// EXTERNAL MODULE: ./components/container/index.jsx + 1 modules
var container = __webpack_require__(3223);
;// CONCATENATED MODULE: ./node_modules/clsx/dist/clsx.m.js
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ var clsx_m = (clsx);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChevronRightIcon.js


function ChevronRightIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.25 4.5l7.5 7.5-7.5 7.5"
  }));
}

const ForwardRef = react.forwardRef(ChevronRightIcon);
/* harmony default export */ var esm_ChevronRightIcon = (ForwardRef);
;// CONCATENATED MODULE: ./components/blog/Card.jsx




function Card(param) {
    let { as: Component = "div" , className , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        className: clsx_m(className, "group relative flex flex-col items-start text-softWhite hover:text-black"),
        children: children
    });
}
Card.Link = function CardLink(param) {
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute -inset-y-6 -inset-x-4 z-0 scale-95 bg-zinc-50 opacity-0 transition group-hover:scale-100 group-hover:opacity-100 dark:bg-zinc-800/50 sm:-inset-x-6 sm:rounded-2xl"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                ...props,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "absolute -inset-y-6 -inset-x-4 z-20 sm:-inset-x-6 sm:rounded-2xl"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "relative z-10",
                            children: children
                        })
                    ]
                })
            })
        ]
    });
};
Card.Title = function CardTitle(param) {
    let { as: Component = "h2" , href , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, {
        className: "text-base font-semibold tracking-tight ",
        children: href ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Link, {
            href: href,
            children: children
        }) : children
    });
};
Card.Description = function CardDescription(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "relative z-10 mt-2 text-sm ",
        children: children
    });
};
Card.Cta = function CardCta(param) {
    let { children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        "aria-hidden": "true",
        className: "relative z-10 mt-4 flex items-center text-sm font-medium text-drDocBlue mb-1",
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_ChevronRightIcon, {
                className: "ml-1 -mb-1 h-4 w-4 text-drDocBlue"
            })
        ]
    });
};
Card.Eyebrow = function CardEyebrow(param) {
    let { as: Component = "p" , decorate =false , className , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Component, {
        className: clsx_m(className, "relative z-10 order-first mb-3 flex items-center text-sm ", decorate && "pl-3.5"),
        ...props,
        children: [
            decorate && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute inset-y-0 left-0 flex items-center",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "h-4 w-0.5 rounded-full bg-zinc-200 dark:bg-zinc-500"
                })
            }),
            children
        ]
    });
};

;// CONCATENATED MODULE: ./pages/blog/index.js








function Article(param) {
    let { article  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/blog/".concat(article.slug),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
            className: "text-gray-800 border-l border-white hover:bg-white hover:text-gray-800 hover:rounded-lg p-4",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    src: article.imageUrl,
                    className: "my-4"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                    className: "text-lg font-header font-bold",
                    children: article.title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-sm text-gray-600",
                    children: dayjs_min_default()(article.publishDate).format("MMM D, YYYY")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mt-2 text-sm text-gray-600 ",
                    children: article.seoDescription
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card.Cta, {
                    children: "Read article"
                })
            ]
        })
    });
}
var __N_SSG = true;
function ArticlesIndex(param) {
    let { articles =[]  } = param;
    var _articles_;
    const main = articles === null || articles === void 0 ? void 0 : articles.slice(1, 3);
    const remainder = articles === null || articles === void 0 ? void 0 : articles.slice(3);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(container/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                ...(0,seo/* createSEOPageConfig */.Cd)(pageConfig/* configSet.blogHome */.r.blogHome)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: " min-h-screen",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                        className: "text-black mt-24 mb-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mt-10 text-5xl font-header tracking-tight text-gray-900 sm:text-6xl",
                                children: "Mastering Medical Efficiency: Your Essential Guide to Next-Level Care"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-6 text-lg leading-8 text-gray-600",
                                children: "Unlock the power of automated documentation with Dr.Doc AI, and transform the way you focus on patient care and work-life balance."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:pl-6 ",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col lg:grid grid-cols-2 gap-4 border-b pb-4 border-gray-700",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Article, {
                                        article: articles[0]
                                    }, (_articles_ = articles[0]) === null || _articles_ === void 0 ? void 0 : _articles_.slug),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-col lg:grid grid-cols-2 gap-4",
                                        children: main.map((entry)=>{
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(Article, {
                                                article: entry
                                            }, entry === null || entry === void 0 ? void 0 : entry.slug);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-col items-start lg:grid grid-cols-4 gap-4 h-full",
                                children: remainder.map((article)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Article, {
                                        article: article
                                    }, article.slug))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 3298:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cd": function() { return /* binding */ createSEOPageConfig; },
/* harmony export */   "JV": function() { return /* binding */ BlogSeo; },
/* harmony export */   "WQ": function() { return /* binding */ createSEOConfig; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3517);



const getImage = function() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (data.imageUrl) {
        return [
            {
                url: data.imageUrl,
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    if (data.slug) {
        return [
            {
                url: "/api/blog-image/".concat(data.slug),
                width: 600,
                height: 300,
                alt: data.title
            }
        ];
    }
    return [
        {
            url: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.websiteLogo */ .v.websiteLogo,
            width: 280,
            height: 280,
            alt: "JRO"
        }
    ];
};
function BlogSeo(param) {
    let { data  } = param;
    if (!data) return null;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .ArticleJsonLd */ .dX, {
        url: data.canonicalUrl,
        title: data.title,
        images: getImage(data).map((file)=>file.url),
        datePublished: data.publishDate,
        dateModified: data.modifiedDate,
        authorName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherName: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.author */ .v.author,
        publisherLogo: "https://www.example.com/photos/logo.jpg",
        description: description
    });
}
function createSEOConfig() {
    let data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const title = data.title || _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.defaultPageTitle */ .v.defaultPageTitle;
    const description = data.seoDescription ? data.seoDescription : _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteDescription */ .v.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: data.canonicalUrl,
            title,
            description,
            images: getImage(data),
            site_name: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.siteName */ .v.siteName
        },
        twitter: {
            handle: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            site: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterHandle */ .v.twitterHandle,
            cardType: _lib_pageConfig__WEBPACK_IMPORTED_MODULE_2__/* .config.twitterCardType */ .v.twitterCardType
        }
    };
}
function createSEOPageConfig() {
    let config = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!config) return null;
    const title = config.defaultPageTitle;
    const description = config.siteDescription;
    return {
        title,
        description,
        openGraph: {
            type: "website",
            locale: "en_US",
            url: config.canonicalUrl,
            title,
            description,
            images: getImage(config),
            site_name: config.siteName
        },
        twitter: {
            handle: config.twitterHandle,
            site: config.twitterHandle,
            cardType: config.twitterCardType
        }
    };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [228,962,216,774,888,179], function() { return __webpack_exec__(7286); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);